var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("templates")))]),
      _vm._v(" "),
      _c("el-card", { staticClass: "no-shadow" }, [_c("templates-table")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }